import axios from 'axios';

const getProductsData = async (query, page=1, perPage=12) => {
    let data = {
        'client': GLOBAL.client,
        'query': query,
        'page': page,
        'perPage': perPage,
    }
    return axios
        .post(
            GLOBAL.root + 'visualizer/xhr/client/get-products-data.php',
            data
        )
        .then((d) => d.data)
}

const getProductsFilter = async (query) => {
    let data = {
        'client': GLOBAL.client,
        'query': query,
    }
    return axios
        .post(
            GLOBAL.root + 'visualizer/xhr/client/get-products-filter.php',
            data
        )
        .then((d) => d.data)
}

const getProductsOptions = async (query) => {
    let data = {
        'client': GLOBAL.client,
        'query': query,
    }
    return axios
        .post(
            GLOBAL.root + 'visualizer/xhr/client/get-products-options.php',
            data
        )
        .then((d) => d.data)
}

const getRoomData = async (query, deviceData) => {
    let data = {
        client: GLOBAL.client,
        roomId : query,
        deviceData : deviceData,
    }
    return axios
        .post(
            GLOBAL.root + 'visualizer/xhr/client/get-room-data.php',
            data
        )
        .then((d) => d.data)
}

const setProductApplication = async (productId, roomId, selectedSurfaces, isConfig) => {
    let data = {
        client: GLOBAL.client,
        product: productId,
        room: roomId,
        selected: selectedSurfaces,
        isConfig : isConfig,
    }
    return axios
        .post(
            GLOBAL.root + 'visualizer/xhr/client/set-product-application.php',
            data
        )
        .then((d) => d.data)
}

export {
    getProductsData,
    getProductsFilter,
    getProductsOptions,
    getRoomData,
    setProductApplication,
};